import Link from 'next/link';
import {P} from "@/components/ui/P"
import {DTOAd} from "@/app/(site)/obyavleniya/page";
import {ToggleFavorite} from "@/components/adsPage/ToggleFavorite";
import React from "react";

export const AdCard = ({id, title, price, datePublish, photos, address, type}: DTOAd) => {
    return (
        <Link href={`/obyavleniya/${id}`}
              className="block rounded-2xl overflow-hidden shadow hover:shadow-lg bg-white transition-all duration-300">
            <div className="relative w-full h-48">
                <img
                    src={photos?.[0] || '/no-image.jpg'}
                    alt={title}
                    className="w-full h-48 object-cover"
                />
                <div className="absolute top-2 left-2 bg-green-600 text-white text-xs px-3 py-1 rounded-full">
                    {type}
                </div>
            </div>
                <div className="relative p-3 flex flex-col gap-1">
                    <P className={'text-green-600'}> {Number(price).toLocaleString('ru-RU')} ₽ </P>
                    <P size={'m'} className="text-gray-800 line-clamp-2">{title}</P>
                    <P size={'s'}>{address}</P>
                    <P size={'s'} className={'text-[10px] text-gray-400 text-right mt-3'}>{datePublish}</P>
                    <div className={'absolute top-3 right-3'}>
                        <ToggleFavorite id={id}/>
                    </div>

            </div>
        </Link>
    );
};
